import RotateControl from './RotateControl';

export default RotateControl;
